import { render, staticRenderFns } from "./YearIndex.vue?vue&type=template&id=300afffb&scoped=true&"
import script from "./YearIndex.vue?vue&type=script&lang=js&"
export * from "./YearIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300afffb",
  null
  
)

export default component.exports